import React from 'react';
import { Caption, Typography } from '../common/Typography';
import CollapsibleNotificationItem from '../notifications/CollapsibleNotificationItem';

/**
 * ClubJoinRequestWithdrawnNotificationItem Component
 * Notification item for withdrawn join requests
 */
const ClubJoinRequestWithdrawnNotificationItem = ({ 
  notification, 
  currentUser,
  onUpdate,
  onClose 
}) => {
  const notificationData = notification.data || {};
  const clubName = notificationData.club_name || 'the club';
  const playerName = notificationData.player_name || 'A player';

  const detailsContent = (
    <>
      <div>
        <Typography variant="muted" as="span">Player: </Typography>{' '}
        <Typography variant="strong" as="span">{playerName}</Typography>
      </div>
    </>
  );

  const metadata = clubName ? (
    <Caption>Club: {clubName}</Caption>
  ) : null;

  return (
    <CollapsibleNotificationItem
      notification={notification}
      borderColor="orange"
      badgeVariant="warning"
      detailsContent={detailsContent}
      metadata={metadata}
    />
  );
};

export default ClubJoinRequestWithdrawnNotificationItem;

